import React, { useEffect, useState } from "react";

import Navigation from "./common/navigation/navigation";
import Home from "./components/home/home";
import About from "./components/about/about";
import Services from "./components/services/services";
import Portfolio from "./components/portfolio/portfolio";
import Testimonial from "./components/testimonial/testimonial";
import Blog from "./components/blog/blog";
import Footer from "./components/footer/footer";
import Skills from "./components/skills/skills";

function App() {
  const [scroll, setOnScroll] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setOnScroll(window.scrollY > 150);
    });
  }, []);

  const scrollUp = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Optional: for smooth scrolling animation
    });
  };

  return (
    <>
      <Navigation />
      <Home />
      <About />
      <Services />
      <Portfolio />
      <Skills/>
      <Testimonial />
      <Blog />
      <Footer />
      <div
        className={scroll ? "back-top back-top-show" : "back-top"}
        onClick={scrollUp}
      >
        <div className="scroll-line"></div>
        <span className="scoll-text">Go Up</span>
      </div>
    </>
  );
}

export default App;
